import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
// import 'bootstrap/dist/css/bootstrap.min.css';
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { axiosNewInstance } from "../../config/Api";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ResetPassword = () => {
  const user = useSelector((state) => state?.user);
  const token = localStorage.getItem("authToken");
  const history = useHistory();
  toast.configure();
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const formik = useFormik({
    initialValues: {
      password: "",
      confirm_password: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .required("Password is required")
        .matches(
          /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/,
          "Password must be at least 8 characters, include one uppercase letter, one number, and one special character"
        ),
      confirm_password: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords do not match")
        .required("Confirm Password is required"),
    }),
    onSubmit: (values) => {
      const dataToSend = {
        user_id: user?.loginuser?.id || "",
        password: values.password,
        confirm_password: values.confirm_password,
      };

      axiosNewInstance
        .post("/api-app/reset-password", dataToSend, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          toast.success("Password has been reset successfully!");

          history.push("/dashboard_admin");
        })
        .catch((error) => {
          toast.error("Failed to reset the password. Please try again.");
        });
    },
  });

  return (
    <div className="container my-5">
      <div className="row justify-content-center">
        <div className="col-md-5">
          <div className="card" style={{border: "none"}}>
            <div className="card-body">
              <h2 className="card-title text-center"
                style={{ fontWeight: "600", marginBottom: "35px" }}
              >
                Reset Password
              </h2>
              <form onSubmit={formik.handleSubmit}>
                <div className="d-none">
                  {user?.loginuser?.id && <p>User ID: {user.loginuser.id}</p>}
                </div>
                <div className="form-group mb-4">
                  <label htmlFor="password">New Password</label>
                  <div className="input-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      name="password"
                      className="form-control"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.password}
                    />
                    <div className="input-group-append">
                      <span
                        className="input-group-text"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                  </div>
                  {formik.touched.password && formik.errors.password && (
                    <div className="text-danger">{formik.errors.password}</div>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="confirm_password">Confirm Password</label>
                  <div className="input-group">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      id="confirm_password"
                      name="confirm_password"
                      className="form-control"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.confirm_password}
                    />
                    <div className="input-group-append">
                      <span
                        className="input-group-text"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                      >
                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                  </div>
                  {formik.touched.confirm_password &&
                    formik.errors.confirm_password && (
                      <div className="text-danger">
                        {formik.errors.confirm_password}
                      </div>
                    )}
                </div>

                <div className="form-group mt-4">
                  <button type="submit" className="btn btn-primary btn-block">
                    Reset Password
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ResetPassword;
